import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { AiGatewayKeysClient, aiGatewayKeysApiRef } from './api';
import { AI_GATEWAY_KEYS_FEATURE_FLAG } from './featureFlags';
import { rootRouteRef } from './routes';

export const aiGatewayKeysPlugin = createPlugin({
  id: 'ai-gateway-keys',
  routes: {
    root: rootRouteRef,
  },
  featureFlags: [{ name: AI_GATEWAY_KEYS_FEATURE_FLAG }],
  apis: [
    createApiFactory({
      api: aiGatewayKeysApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new AiGatewayKeysClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const AiGatewayKeysPage = aiGatewayKeysPlugin.provide(
  createRoutableExtension({
    name: 'AiGatewayKeysPage',
    component: () => import('./components/VirtualKeysPage').then((m) => m.VirtualKeysPage),
    mountPoint: rootRouteRef,
  }),
);
